import { Flex, Menu, Typography } from "antd";
import clsx from "clsx";

import type {
  SidebarMenuProps,
  SidebarProps,
  SidebarStepperProps,
} from "./types";

import { useAutoExpandMenu } from "../../hooks";
import logoSrc from "../../icons/logo.svg";
import s from "./Sidebar.module.css";
import { Stepper } from "./Stepper";

const Sidebar = (props: SidebarProps) => {
  const menuProps = props as SidebarMenuProps;
  const { type = "menu", theme, inlineCollapsed } = menuProps;
  const {
    menuKey,
    selectedKeys = [],
    defaultOpenKeys = [],
  } = useAutoExpandMenu(menuProps.items);
  const menuRenderKey = `${menuKey ?? ""}-${menuProps.items?.length ?? 0}`;

  return (
    <Flex
      className={s.sidebarContainer}
      gap="middle"
      vertical
      justify="space-between"
    >
      {type === "menu" ? (
        <>
          <Menu
            key={menuRenderKey}
            {...props}
            mode="inline"
            items={menuProps.items}
            theme={theme}
            selectedKeys={selectedKeys}
            defaultOpenKeys={defaultOpenKeys}
          />
          {!inlineCollapsed && (
            <Flex
              vertical
              justify="center"
              align="center"
              className={s.sidebarLogoContainer}
              data-testid="sidebar-logo-container"
            >
              <Typography.Text
                type="secondary"
                className={clsx({
                  [s.sidebarLogoTextDark]: theme === "dark",
                  [s.sidebarLogoTextLight]: theme === "light",
                })}
                data-testid="sidebar-logo-text"
              >
                Powered by
              </Typography.Text>
              <img src={logoSrc} width={80} height={32} alt="Thredd" />
            </Flex>
          )}
        </>
      ) : (
        <Stepper items={(props as SidebarStepperProps)?.items} />
      )}
    </Flex>
  );
};

export default Sidebar;
